import firedux from '../firedux'
import {dispatch} from '../store'

import {
  GROUP_CHAT_ENDPOINT,
  GROUP_CHAT_SCOPES
} from '../../config/constants'

import setGroupChats from '../actions/set_group_chats'

const onGroups = (scope, snapshot) => dispatch(setGroupChats(snapshot.val(), scope))
const onGlobalGroups = (snapshot) => onGroups(GROUP_CHAT_SCOPES.GLOBAL, snapshot)
const onPrivateGroups = (snapshot) => onGroups(GROUP_CHAT_SCOPES.PRIVATE, snapshot)
const onSuperPrivateGroups = (snapshot) => onGroups(GROUP_CHAT_SCOPES.SUPER_PRIVATE, snapshot)
const onDeletedGroups = (snapshot) => onGroups(GROUP_CHAT_SCOPES.DELETED, snapshot)

export const watchGlobalGroupChats = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ENDPOINT).child(GROUP_CHAT_SCOPES.GLOBAL)

  ref.on('value', onGlobalGroups)
}

export const unwatchGlobalGroupChats = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ENDPOINT).child(GROUP_CHAT_SCOPES.GLOBAL)

  ref.off('value', onGlobalGroups)
}


export const watchPrivateGroupChats = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ENDPOINT).child(GROUP_CHAT_SCOPES.PRIVATE)

  ref.on('value', onPrivateGroups)
}

export const unwatchPrivateGroupChats = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ENDPOINT).child(GROUP_CHAT_SCOPES.PRIVATE)

  ref.off('value', onPrivateGroups)
}


export const watchSuperPrivateGroupChats = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ENDPOINT).child(GROUP_CHAT_SCOPES.SUPER_PRIVATE)

  ref.on('value', onSuperPrivateGroups)
}

export const unwatchSuperPrivateGroupChats = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ENDPOINT).child(GROUP_CHAT_SCOPES.SUPER_PRIVATE)

  ref.off('value', onSuperPrivateGroups)
}

export const watchDeletedGroupChats = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ENDPOINT).child(GROUP_CHAT_SCOPES.DELETED)

  ref.on('value', onDeletedGroups)
}

export const unwatchDeletedGroupChats = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ENDPOINT).child(GROUP_CHAT_SCOPES.DELETED)

  ref.off('value', onDeletedGroups)
}

export const watchGroupChats = () => {
  watchGlobalGroupChats()
  watchPrivateGroupChats()
  watchSuperPrivateGroupChats()
}

export const unwatchGroupChats = () => {
  unwatchGlobalGroupChats()
  unwatchPrivateGroupChats()
  unwatchSuperPrivateGroupChats()
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/group_chats.js
 **/